<template>
  <div class="video-draw-polygon"
       :style="{ width: size.width + 'px', height: size.height + 'px' }">
    <canvas id="videoCanvas"
            class="video-draw-canvas"
            :width="size.width"
            :height="size.height"></canvas>
  </div>
</template>
<script>
export default {
  name: "videoDrawPolygon",
  props: {
    size: {
      type: Object,
      default: () => {
        return {
          width: 384,
          height: 216,
        };
      },
    },
  },
  watch: {
    size: {
      handler: function (newVal, oldVal) {
        if (this.canvas) {
          this.redrawPolygon();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data () {
    return {};
  },
  mounted () {
    this.initData();
    this.resetData();
    this.initDraw();
  },
  methods: {
    getDrawData () {
      return this.drawResult;
    },
    setDrawData (drawData) {
      this.drawResult = drawData;
      this.redrawPolygon();
    },
    redrawPolygon () {
      let drawData = Object.assign({}, this.drawResult);
      this.resetData();
      this.computePoint(drawData, "polygons");
      this.computePoint(drawData, "lines");
      if (this.drawTimer) {
        clearTimeout(this.drawTimer);
      }
      this.drawTimer = setTimeout(() => {
        this.setEquipment();
      }, 100);
    },
    computePoint (drawData = {}, key = "polygons") {
      if (drawData[key] && drawData[key].length) {
        drawData[key].forEach((pItem) => {
          let data = [];
          if (pItem && pItem.data && pItem.data.length) {
            const oldSize = pItem.drawSize || this.size;
            let wRate = this.size.width / oldSize.width;
            let hRate = this.size.height / oldSize.height;
            pItem.data.forEach((item) => {
              data.push([
                Math.round(item[0] * wRate),
                Math.round(item[1] * hRate),
              ]);
            });
          }
          this.drawData[key].push({ data });
        });
      }
    },
    initData () {
      this.drawResult = {
        polygons: [],
        lines: [],
      };
    },
    resetData () {
      this.drawData = {
        polygons: [],
        lines: [],
      };
    },
    initDraw () {
      this.canvas = document.getElementById("videoCanvas");
      this.cxt = this.canvas.getContext("2d");
      this.cxt.translate(0, 0);
      this.reClean();
      if (!this.currentcameraflag) {
        let _this = this;
        var x, y;
        (this.canvas.onclick = (e) => {
          x = e.offsetX;
          y = e.offsetY;
          if (this.arr.length >= 3) {
            this.arr.push({
              x,
              y,
            });
          }
          this.arr.length < 3
            ? this.arr.push({
              x,
              y,
            })
            : null;
          _this.drawPolygon(this.cxt, this.arr, 1, "blue");
          this.arr1 = [x, y];
          this.arr2.push(this.arr1);
        }),
          (this.canvas.ondblclick = () => {
            if (this.arr.length > 2) {
              this.arr.splice(this.arr.length - 2, 1);
              this.arr2.splice(this.arr2.length - 2, 1);
              if (this.arr2.length == 2) {
                let line = this.arr2[0][0];
                console.log("line", line);
              }
              this.arr2.push(this.arr2[0]);
              this.arr3.push(this.arr2);
              _this.drawPolygon(
                this.cxt,
                this.arr,
                2,
                "red",
                "rgba(222, 0, 0, .1)",
                true
              );
              this.arr1 = [];
              this.arr2 = [];
              this.arr3 = [];
              this.arr = [];
              _this.cxt.closePath();
              this.arr4 = this.arr3.toString();
            }
            this.$emit('drawComplete', this.drawResult);
          });
      }
    },
    setEquipment () {
      if (!this.canvas) {
        this.initDraw();
      }
      this.reClean(true);
      // 面回填
      if (this.drawData.polygons.length > 0) {
        this.drawData.polygons.forEach((val) => {
          let ary = [];
          val.data.forEach((_data) => {
            ary.push({
              x: _data[0],
              y: _data[1],
            });
          });
          this.drawPolygon(
            this.cxt,
            ary,
            2,
            "red",
            "rgba(222, 0, 0, .1)",
            true
          );
        });
      }
      // 线回填
      if (this.drawData.lines.length > 0) {
        this.drawData.lines.forEach((val) => {
          let ary = [];
          val.data.forEach((_data) => {
            ary.push({
              x: _data[0],
              y: _data[1],
            });
          });
          this.drawPolygon(this.cxt, ary, 1, "red");
        });
      }
    },
    startdraw () {
      this.reClean();
    },
    drawPoint (cxt, x, y, w, borderWidth, borderColor, fillColor) {
      this.cxt.beginPath();
      this.cxt.moveTo(x - w, y - w);
      this.cxt.lineTo(x + w, y - w);
      this.cxt.lineTo(x + w, y + w);
      this.cxt.lineTo(x - w, y + w);
      this.cxt.lineWidth = borderWidth;
      this.cxt.strokeStyle = borderColor;
      this.cxt.fillStyle = fillColor;
      this.cxt.closePath();
      this.cxt.fill();
      this.cxt.stroke();
      this.drawcomplete();
    },
    drawPolygon (cxt, dbl, borderWidth, borderColor, fillColor, t) {
      let _this = this;
      for (let i = 0; i < dbl.length; i++) {
        _this.drawPoint(cxt, dbl[i].x, dbl[i].y, 2, 1, "red", "skyblue");
      }
      this.cxt.moveTo(dbl[0].x, dbl[0].y);
      for (let j = 1; j < dbl.length; j++) {
        this.cxt.lineTo(dbl[j].x, dbl[j].y);
      }
      if (t) {
        this.cxt.closePath();
        this.cxt.fillStyle = fillColor;
        this.cxt.fill();
      }
      this.cxt.lineWidth = borderWidth;
      this.cxt.strokeStyle = borderColor;
      this.cxt.stroke();
    },
    //绘制完成
    drawcomplete () {
      let dataList = [];
      this.currentcameraflag = true;
      this.resetFlag = false;
      this.arr3.map((val) => {
        val.map((item, index) => {
          if (index != val.length - 1) {
            dataList.push(item);
          }
        });
      });
      if (this.arr3 && this.arr3.length > 0) {
        let lineList = [];
        let areaList = [];
        if (dataList.length > 2) {
          areaList = dataList;
        } else {
          lineList = dataList;
        }
        if (dataList.length > 2) {
          if (this.drawResult.polygons.length == 0) {
            this.drawResult.polygons.push({
              data: areaList,
              drawSize: this.size,
            });
          } else {
            let area_return = this.drawResult.polygons.find((item) => {
              return item.data.toString() == areaList.toString();
            });
            if (!area_return) {
              this.drawResult.polygons.push({
                data: areaList,
                drawSize: this.size,
              });
            }
          }
        } else if (dataList.length == 2) {
          if (this.drawResult.lines.length == 0) {
            this.drawResult.lines.push({
              data: lineList,
              drawSize: this.size,
              properties: { type: 0 }
            });
            this.$message('此线段为车头识别线');
          } else if (this.drawResult.lines.length < 3) {
            let lines_return = this.drawResult.lines.find((item) => {
              return item.data.toString() == lineList.toString();
            });
            if (!lines_return) {
              this.drawResult.lines.push({
                data: lineList,
                drawSize: this.size,
                properties: { type: 1 }
              });
              this.$message('此线段为车尾识别线');
            }
          } else {
            console.log('line++++', this.drawResult.lines)
            this.$message.error('最多选择两条识别线，请清除后重新绘制')
          }
        }
        let flag = false;
      }
    },
    clearUp () {
      if (this.arr.length > 2) {
        this.drawPolygon(
          this.cxt,
          this.arr,
          1,
          "red",
          "rgba(0,  0, 0, .1)",
          true
        );
        // 这里执行完成闭合之后，清空坐标数组，便于另外新建
        this.arr = [];
        this.cxt.closePath();
      }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
      this.currentcameraflag = false;
      if (this.taskConfig && this.taskConfig.length > 0) {
        for (let i = 0; i < this.taskConfig.length; i++) {
          if (this.taskConfig[i].cameraId == this.selectedCameraId) {
            this.taskConfig.splice(i, 1);
          }
        }
      }
      let param = {
        cameraId: this.selectedCameraId,
        targetType: this.targetType,
      };
      this.taskConfig.push(param);
      if (this.cameraLine && this.cameraLine.length > 0) {
        for (let i = 0; i < this.cameraLine.length; i++) {
          if (this.cameraLine[i].cameraId == this.selectedCameraId) {
            this.cameraLine.splice(i, 1);
          }
        }
      }
      let cameraLineParam = {
        cameraId: this.selectedCameraId,
      };
      this.cameraLine.push(cameraLineParam);
    },
    clean () {
      this.resetFlag = true;
      if (this.arr.length > 2) {
        this.drawPolygon(
          this.cxt,
          this.arr,
          1,
          "red",
          "rgba(0,  0, 0, .1)",
          true
        );
        // 这里执行完成闭合之后，清空坐标数组，便于另外新建
        this.arr = [];
        this.cxt.closePath();
      }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
      this.currentcameraflag = true;
    },
    reClean (type) {
      if (!type) {
        this.resetData();
      }
      this.arr1 = [];
      this.arr2 = [];
      this.arr3 = [];
      this.dbl = [];
      this.arr = [];
      this.cxt.closePath();
      this.cxt.stroke();
      this.canvas.width = this.canvas.width;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>